import { ManuteRequestConfig } from '@/api/types';
import { CalendarQueryParams, FullcalendarQueryParams, CalendarRequest } from '@/api/requests/calendar/types';

/**
 * Request to find all calendars.
 */
export const ALL = (params?: CalendarQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: '/calendars',
    params
});

/**
 * Request to get fullcalendar resources.
 */
export const RESOURCES = (params?: FullcalendarQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: '/calendars/resources',
    params: {
        start: params?.start,
        self: params?.self,
        end: params?.end,
        company_ids: params?.companyIds,
    }
});

/**
 * Request to get fullcalendar resources.
 */
export const FULLCALENDAR_EVENTS = (params?: FullcalendarQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: '/calendars/fullcalendar-events',
    params
});

/**
 * Request to find a calendar by id.
 * @param calendarId
 */
export const FIND = (calendarId: string | number): ManuteRequestConfig => ({
    method: 'GET',
    url: `/calendars/${calendarId}`,
});

/**
 * Request to save a new calendar.
 * @param calendar
 */
export const SAVE = (calendar: CalendarRequest): ManuteRequestConfig => ({
    method: 'POST',
    url: `/calendars`,
    data: calendar,
});

/**
 * Request to update an existing calendar.
 * @param calendarId
 * @param calendar
 */
export const UPDATE = (calendarId: string | number, calendar: CalendarRequest): ManuteRequestConfig => ({
    method: 'PUT',
    url: `/calendars/${calendarId}`,
    data: calendar,
});

/**
 * Request to delete a calendar.
 * @param calendarId
 */
export const DESTROY = (calendarId: string | number): ManuteRequestConfig => ({
    method: 'DELETE',
    url: `/calendars/${calendarId}`,
});
